import { createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../axiosInstance";

export const fetchDocumentApprovals = createAsyncThunk(
    "community/fetchDocumentApprovalsByCommunityId",
    async ({ page, page_size, searchQuery }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/community/visitor-document-admin`, {
                params: {
                    page: page,
                    page_size: page_size,
                    search: searchQuery,
                }
            });
            return response.data;
        } catch (error) {
            // Handle errors appropriately
            return rejectWithValue(
                error.response ? error.response.data : "An error occurred"
            );
        }
    }
);

export const fetchDocumentApprovalsByCommunityId = createAsyncThunk(
    "community/fetchDocumentApprovalsByCommunityId",
    async (id, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/community/visitor-document-admin/${id}`);
            return response.data;
        } catch (error) {
            // Handle errors appropriately
            return rejectWithValue(
                error.response ? error.response.data : "An error occurred"
            );
        }
    }
);

export const updateVisitorDocumentStatus = createAsyncThunk(
    "community/updateVisitorDocumentStatus",
    async ({ document_id, approval_status, user_id, document_name }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(`/community/visitor-document-admin`, {
                document_id: document_id,
                approval_status: approval_status,
                user_id: user_id,
                document_name: document_name
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);

export const fetchFactCheckApprovals = createAsyncThunk(
    "community/fetchFactCheckApprovalsByCommunityId",
    async ({ page, page_size, searchQuery }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/community/visitor-fact-check-admin`, {
                params: {
                    page: page,
                    page_size: page_size,
                    search: searchQuery,
                }
            });
            return response.data;
        } catch (error) {
            // Handle errors appropriately
            return rejectWithValue(
                error.response ? error.response.data : "An error occurred"
            );
        }
    }
);

export const fetchFactCheckApprovalsByCommunityId = createAsyncThunk(
    "community/fetchFactCheckApprovalsByCommunityId",
    async (id, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(`/community/visitor-fact-check-admin/${id}`);
            return response.data;
        } catch (error) {
            // Handle errors appropriately
            return rejectWithValue(
                error.response ? error.response.data : "An error occurred"
            );
        }
    }
);

export const updateFactCheckStatus = createAsyncThunk(
    "community/updateVisitorDocumentStatus",
    async ({ fact_check_id, approval_status, user_id }, { rejectWithValue }) => {
        try {
            const response = await axiosInstance.put(`/community/visitor-fact-check-admin`, {
                fact_check_id: fact_check_id,
                approval_status: approval_status,
                user_id: user_id,
            });
            return response.data;
        } catch (error) {
            return rejectWithValue(
                error.response ? error.response.data : error.message
            );
        }
    }
);